var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _g, _path26, _path27, _path28, _g2, _path29, _path30, _path31, _g3, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoResults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 178,
    viewBox: "0 0 176 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7819 40.7955C54.4224 -4.51696 141.168 -7.04965 166.674 28.8901C180.728 48.6927 174.855 78.2941 171.958 92.8996C166.625 119.777 153.476 137.081 150.605 140.751C143.638 149.657 126.715 171.29 101.254 176.235C57.7489 184.684 3.46454 141.665 0.456978 93.1296C-1.27683 65.1477 14.6141 44.713 17.7819 40.7955Z",
    fill: "#F4F7FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1333 151.932C40.3143 152.051 47.5071 152.035 54.7057 151.883C54.8082 151.985 58.9092 139.573 52.5566 131.883C39.9571 116.943 51.2957 106.682 55.0306 100.187C60.779 91.1025 59.944 80.2844 48.0746 78.477C34.9402 76.2581 35.0906 57.8131 39.793 41.6688C42.7687 33.8901 34.9993 22.8709 26.1935 19.3758C17.2313 15.6138 7.23276 19.3759 2.13849 34.9973C-4.77346 52.9435 9.96847 66.3933 14.7038 76.5304C19.3661 86.4835 4.50473 91.9475 14.4977 101.581C22.8493 110.067 33.9211 116.872 28.3391 125.299C22.6533 133.607 22.6909 141.05 33.1333 151.932Z",
    fill: "url(#paint0_linear_6783_40298)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6783_40298",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 18,
    width: 59,
    height: 135
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1333 151.932C40.3143 152.051 47.5071 152.035 54.7057 151.883C54.8082 151.985 58.9092 139.573 52.5566 131.883C39.9571 116.943 51.2957 106.682 55.0306 100.187C60.779 91.1025 59.944 80.2844 48.0746 78.477C34.9402 76.2581 35.0906 57.8131 39.793 41.6688C42.7687 33.8901 34.9993 22.8709 26.1935 19.3758C17.2313 15.6138 7.23276 19.3759 2.13849 34.9973C-4.77346 52.9435 9.96847 66.3933 14.7038 76.5304C19.3661 86.4835 4.50473 91.9475 14.4977 101.581C22.8493 110.067 33.9211 116.872 28.3391 125.299C22.6533 133.607 22.6909 141.05 33.1333 151.932Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6783_40298)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8256 154.046C42.8435 153.934 39.8587 126.201 31.8793 98.4981C30.8657 94.0555 29.7176 89.5548 28.6075 85.2024C22.4243 60.9638 16.584 38.0692 29.5345 15.3126L29.1463 15.146C16.1356 38.0089 21.9905 60.9606 28.1892 85.2601C29.299 89.6106 30.4466 94.1093 31.4614 98.5567C39.4837 126.41 42.402 153.828 42.3999 153.996L42.8256 154.046Z",
    fill: "#BEB8F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0308 62.7621L23.3797 62.57C16.5291 54.2227 8.4804 42.5928 4.15638 36.345C0.656727 31.2884 0.638435 31.2875 0.417806 31.2861L0.42607 31.4648L0.305664 31.6035C0.510524 31.7755 1.95729 33.8658 3.78873 36.5122C8.11584 42.7644 16.1701 54.4024 23.0308 62.7621Z",
    fill: "#BEB8F2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1724 52.4668C24.9537 44.4174 29.8165 39.5372 33.4061 36.8606C37.3163 33.945 40.7723 32.8346 41.1793 32.8307L41.169 32.6919L41.3437 32.5284C41.2461 32.4547 41.1216 32.4632 40.9257 32.5044C38.1216 33.0959 26.6513 38.1976 21.7607 52.3519L22.1724 52.4668L22.1724 52.4668Z",
    fill: "#BEB8F2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9854 116.483L36.4135 116.5C36.3613 99.6178 52.0769 86.0565 58.8362 81.0094C59.1993 80.7384 59.3163 80.6502 59.3613 80.6019L59.0183 80.374L59.1898 80.4879L59.0193 80.373C58.9859 80.4065 58.7802 80.5599 58.5424 80.7375C53.6677 84.3773 49.4397 88.328 45.976 92.4797C39.3222 100.455 35.9609 108.531 35.9855 116.483L35.9854 116.483Z",
    fill: "#BEB8F2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52117 92.3304L9.53082 92.1548L9.44037 92.311L9.31934 92.1178L9.50067 91.9747C9.50124 91.9746 9.50219 91.9746 9.50338 91.9747C9.79655 91.9883 27.479 95.2801 34.3411 107.785L33.9537 107.92C27.1601 95.5404 9.69084 92.3501 9.52117 92.3304Z",
    fill: "#BEB8F2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2607 149.505C42.5831 146.125 44.8359 140.599 53.7361 133.464C54.0728 133.194 54.2401 133.028 54.2381 132.966L53.8104 132.958L54.0242 132.962L53.8429 132.862C53.8127 132.895 53.6362 133.036 53.4321 133.2C44.4408 140.408 42.1622 146.02 41.834 149.459L42.2607 149.505V149.505Z",
    fill: "#BEB8F2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.933 142.879L41.3549 142.837C40.1029 136.555 30.6409 130.772 25.1122 127.884C24.9369 127.793 24.824 127.734 24.7841 127.71L24.5459 127.997C24.5887 128.022 24.71 128.086 24.8988 128.185C30.362 131.039 39.7099 136.742 40.933 142.879L40.933 142.879Z",
    fill: "#BEB8F2"
  })))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4253 92.5464C65.8915 94.8684 67.3577 96.6125 68.8957 98.8142C57.5052 100.841 46.8962 104.883 35.3517 106.958C39.5669 92.4361 45.1232 85.1703 36.7362 69.7728C32.8004 62.5469 22.926 49.4589 24.2253 41.1832C25.7056 31.755 32.3678 32.4621 28.8877 25.1689C23.4485 13.7699 26.1926 -0.32015 43.7342 0.756376C61.047 1.8189 70.9703 45.7364 64.6566 59.8856C61.6967 73.0022 56.7692 80.4214 64.4253 92.5462L64.4253 92.5464Z",
    fill: "url(#paint1_linear_6783_40298)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6783_40298",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 0,
    width: 45,
    height: 107
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4253 92.5464C65.8915 94.8684 67.3577 96.6125 68.8957 98.8142C57.5052 100.841 46.8962 104.883 35.3517 106.958C39.5669 92.4361 45.1232 85.1703 36.7362 69.7728C32.8004 62.5469 22.926 49.4589 24.2253 41.1832C25.7056 31.755 32.3678 32.4621 28.8877 25.1689C23.4485 13.7699 26.1926 -0.32015 43.7342 0.756376C61.047 1.8189 70.9703 45.7364 64.6566 59.8856C61.6967 73.0022 56.7692 80.4214 64.4253 92.5462L64.4253 92.5464Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6783_40298)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M50.986 101.709L51.2353 101.701C51.0975 97.4366 51.2934 93.1096 51.4829 88.9252L51.5543 87.3354C51.7027 83.9691 51.7754 80.9555 51.8394 78.2967C51.8755 76.8073 51.9095 75.3919 51.9536 74.0238C52.0888 69.8383 52.1913 66.9096 52.2423 65.4536L52.2755 64.492C52.6423 53.0149 48.9186 37.2846 46.9181 28.8336C46.7015 27.9191 46.508 27.1015 46.3459 26.3983C43.5584 14.3097 42.1055 1.39742 42.0278 -11.9795L41.7783 -11.9781C41.8562 1.41729 43.3112 14.3478 46.1029 26.4543C46.2651 27.1581 46.4588 27.976 46.6754 28.8911C48.6732 37.3308 52.3921 53.0401 52.0263 64.4841L51.9931 65.445C51.9421 66.9011 51.8396 69.8301 51.7044 74.0159C51.6602 75.3845 51.6261 76.8006 51.5902 78.2908C51.526 80.9485 51.4534 83.9606 51.3051 87.3246L51.2338 88.914C51.0442 93.1031 50.8479 97.435 50.986 101.709Z",
    fill: "#FCFDFE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M51.833 80.4964L52.0823 80.4923C51.9641 72.8962 48.7651 64.0215 42.8309 54.8275C37.8883 47.1697 31.1764 39.5599 24.416 33.9492L24.2568 34.141C37.3601 45.016 51.5786 64.1609 51.833 80.4964Z",
    fill: "#FCFDFE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0276 30.3009L47.2482 30.1848C44.1896 24.3724 40.3785 18.9128 36.6927 13.6328C34.1703 10.0195 31.5621 6.28303 29.2164 2.46436L29.0039 2.59498C31.3535 6.41984 33.9639 10.1594 36.4883 13.7756C40.1696 19.0493 43.9763 24.5022 47.0276 30.3008V30.3009Z",
    fill: "#FCFDFE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3642 51.0921C52.8201 42.0777 58.8567 30.6684 64.2827 26.676L64.135 26.4751C58.6651 30.4996 52.5826 41.9843 51.1182 51.0524L51.3642 51.0921Z",
    fill: "#FCFDFE"
  })))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5078 49.0013C63.3042 62.9755 54.8014 62.7286 43.9326 62.8879C49.8015 74.6245 55.084 86.2684 60.4039 98.1039C67.6766 97.8893 72.8818 97.6002 74.0273 88.8416C75.3229 78.9357 75.742 73.1761 85.2368 67.6179C94.7316 62.0597 99.9162 51.9298 93.1595 43.2502C86.0492 34.1163 90.4183 17.5961 79.1805 13.0043C59.5991 5.00321 59.6373 34.4498 61.5078 49.0013Z",
    fill: "url(#paint2_linear_6783_40298)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_6783_40298",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 11,
    width: 54,
    height: 88
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5078 49.0013C63.3042 62.9755 54.8014 62.7286 43.9326 62.8879C49.8015 74.6245 55.084 86.2684 60.4039 98.1039C67.6766 97.8893 72.8818 97.6002 74.0273 88.8416C75.3229 78.9357 75.742 73.1761 85.2368 67.6179C94.7316 62.0597 99.9162 51.9298 93.1595 43.2502C86.0492 34.1163 90.4183 17.5961 79.1805 13.0043C59.5991 5.00321 59.6373 34.4498 61.5078 49.0013Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_6783_40298)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9636 82.1295C64.4081 73.7738 71.2123 66.5762 75.549 56.4383C79.6997 46.7355 80.2406 37.6209 77.3577 25.9618C75.8641 19.9208 75.4768 15.4236 75.0565 9.25195L74.8076 9.26879C75.2288 15.4537 75.617 19.961 77.1156 26.0214C79.9844 37.6239 79.4473 46.6913 75.3198 56.3403C71.0009 66.4366 64.213 73.6158 55.7881 81.9522L55.9636 82.1295Z",
    fill: "#FCFDFE"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M74.28 93.9969L74.412 93.7854C71.094 91.7161 67.7778 90.2444 64.2737 89.2865C62.4806 88.7964 60.7602 88.6364 58.7286 88.5469L58.7178 88.7961C60.7325 88.8849 62.4371 89.0431 64.2079 89.5272C67.6882 90.4785 70.9828 91.9406 74.28 93.9969Z",
    fill: "#FCFDFE"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5469 62.457C78.9114 56.1358 88.0869 52.0055 98.3832 50.8274L98.3549 50.5796C88.003 51.7642 78.7752 55.9194 72.3711 62.28L72.5469 62.457Z",
    fill: "#FCFDFE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9371 38.8702L79.1809 38.8182C78.902 37.5121 72.8493 26.3073 71.0009 22.9042C67.1761 15.8627 62.9657 8.33203 62.54 7.91846L62.3662 8.0974C62.72 8.44127 66.5739 15.2763 70.7818 23.0233C74.5825 30.0209 78.7209 37.8586 78.9371 38.8703L78.9371 38.8702Z",
    fill: "#FCFDFE"
  })))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M120.919 177.302L170.429 173.536V34.2147L120.919 30.5479V177.302Z",
    fill: "url(#paint3_linear_6783_40298)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M165.633 85.0181V144.226H166.602V159.38H120.919V85.0181H165.633Z",
    fill: "#D8DEE8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_6783_40298",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 120,
    y: 37,
    width: 47,
    height: 134
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M166.602 167.446V40.3118L120.919 37.2412V170.608L166.602 167.446Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_6783_40298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.101 20.3936C106.101 20.3936 106.053 52.444 98.8657 67.1565C91.6786 81.8691 88.9744 96.1931 94.3827 104.58C99.7911 112.967 120.92 100.169 120.92 100.169C120.92 100.169 130.889 107.203 135.396 122.254C139.903 137.305 169.198 149.846 175.508 145.604C181.818 141.361 179.113 27.775 179.113 27.775L106.101 20.3936Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.86 154.241C176.86 154.241 159.108 162.518 145.675 154.869C132.241 147.22 120.92 133.474 120.92 133.474C120.92 133.474 107.258 141.845 99.9188 141.378C92.5799 140.91 87.1507 117.363 87.1507 117.363C87.1507 117.363 75.0028 111.326 69.5944 99.0765C64.186 86.8271 47.585 73.4867 38.4964 70.6923C29.408 67.8978 24.0742 73.1147 24.0742 73.1147L26.3277 179.885L166.603 187.231L176.86 154.241Z",
    fill: "white"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M87.15 38.7466H29.4072V169.296H87.15V38.7466Z",
    fill: "url(#paint4_linear_6783_40298)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1494 163.332L87.1494 44.6196H34.0884L34.0884 163.332H87.1494Z",
    fill: "#D8DEE8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_6783_40298",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 44,
    width: 54,
    height: 120
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1494 163.332L87.1494 44.6196H34.0884L34.0884 163.332H87.1494Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_6783_40298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.859 154.241C176.859 154.241 159.107 162.518 145.674 154.869C132.24 147.22 120.919 133.474 120.919 133.474C120.919 133.474 107.257 141.845 99.9178 141.378C92.5789 140.91 87.1497 117.363 87.1497 117.363C87.1497 117.363 75.0018 111.326 69.5934 99.0765C64.1851 86.8271 47.584 73.4867 38.4955 70.6923C29.407 67.8978 24.0732 73.1147 24.0732 73.1147L26.3267 179.885L166.602 187.231L176.859 154.241Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.914 24.3799C96.914 24.3799 101.7 46.3406 96.914 52.1615C92.1278 57.9825 88.4807 74.6425 87.1494 79.1573C85.8181 83.6721 75.4521 93.5542 70.0438 84.5569C64.6355 75.5595 56.5229 68.9967 52.4667 65.9684C48.4105 62.9401 22.7208 59.8301 21.3687 57.5542C20.0166 55.2783 19.1152 29.4535 19.1152 29.4535L96.914 24.3799Z",
    fill: "white"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1504 169.297L120.919 177.302V30.5479L87.1504 38.7468V169.297Z",
    fill: "url(#paint5_linear_6783_40298)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1504 143.445V46.1447L99.0411 42.0743L104.939 40.7714L105.956 40.6519V100.015H120.919V143.445H87.1504Z",
    fill: "#BFC8D6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_6783_40298",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 87,
    y: 37,
    width: 34,
    height: 134
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M120.919 170.608V37.2412L87.1504 44.701V163.342L120.919 170.608Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_6783_40298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.101 20.3936C106.101 20.3936 106.053 52.444 98.8657 67.1565C91.6786 81.8691 88.9744 96.1931 94.3827 104.58C99.7911 112.967 120.92 100.169 120.92 100.169C120.92 100.169 130.889 107.203 135.396 122.254C139.903 137.305 169.198 149.846 175.508 145.604C181.818 141.361 179.113 27.775 179.113 27.775L106.101 20.3936Z",
    fill: "#D8DEE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.86 154.241C176.86 154.241 159.108 162.518 145.675 154.869C132.241 147.22 120.92 133.474 120.92 133.474C120.92 133.474 107.258 141.845 99.9188 141.378C92.5799 140.91 87.1507 117.363 87.1507 117.363C87.1507 117.363 75.0028 111.326 69.5944 99.0765C64.186 86.8271 47.585 73.4867 38.4964 70.6923C29.408 67.8978 24.0742 73.1147 24.0742 73.1147L26.3277 179.885L166.603 187.231L176.86 154.241Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.915 24.3799C96.915 24.3799 101.701 46.3406 96.915 52.1615C92.1288 57.9825 88.4816 74.6425 87.1504 79.1573C85.8191 83.6721 75.4531 93.5542 70.0448 84.5569C64.6365 75.5595 56.5239 68.9967 52.4676 65.9684C48.4114 62.9401 22.7218 59.8301 21.3697 57.5542C20.0176 55.2783 19.1162 29.4535 19.1162 29.4535L96.915 24.3799Z",
    fill: "#D8DEE8"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M61.0703 44.6201H60.1689V169.297H61.0703V44.6201Z",
    fill: "url(#paint6_linear_6783_40298)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M144.211 38.7769H143.31V169.297H144.211V38.7769Z",
    fill: "url(#paint7_linear_6783_40298)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M34.0889 86.3446H87.2027L87.2541 86.3323L120.953 78.3227L166.564 82.1752L166.64 81.2769L120.885 77.4126L120.815 77.4293L87.0969 85.4432H34.0889V86.3446Z",
    fill: "url(#paint8_linear_6783_40298)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M104.031 34.455C104.031 47.0446 120.495 77.2732 127.321 87.8116C128.481 89.6031 133.254 89.27 134.414 87.4786C141.24 76.9402 159.856 47.0446 159.856 34.4551C159.856 19.0393 147.36 6.54248 131.944 6.54248C116.528 6.54248 104.031 19.0393 104.031 34.455Z",
    fill: "#654D8F"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M101.001 34.4551C101.001 47.0447 119.617 76.9402 126.443 87.4786C127.603 89.2701 130.224 89.2701 131.384 87.4786C138.21 76.9402 156.826 47.0446 156.826 34.4551C156.826 19.0393 144.329 6.54248 128.914 6.54248C113.498 6.54248 101.001 19.0394 101.001 34.4551Z",
    fill: "#8176AC"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M142.547 49.092C150.358 41.2814 150.358 28.618 142.547 20.8074C134.736 12.9968 122.073 12.9968 114.262 20.8074C106.452 28.618 106.452 41.2814 114.262 49.092C122.073 56.9026 134.736 56.9026 142.547 49.092Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M141.705 48.2498C149.05 40.9044 149.05 28.9951 141.705 21.6496C134.36 14.3042 122.45 14.3042 115.105 21.6496C107.759 28.995 107.759 40.9044 115.105 48.2498C122.45 55.5953 134.36 55.5953 141.705 48.2498Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3815 97.3545C80.3815 97.3545 80.1679 92.6427 79.2076 90.459C75.8849 91.3821 60.0731 96.5351 55.0745 98.1682C53.7856 98.5894 53.1451 100.078 53.7923 101.269C53.799 101.282 53.8058 101.294 53.8127 101.306C53.8195 101.318 53.8263 101.331 53.8331 101.342C54.42 102.372 55.6456 102.853 56.7938 102.561C67.0622 99.9497 69.4431 100.21 80.3815 97.3545L80.3815 97.3545Z",
    fill: "#8176AC"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M100.349 94.9002C100.349 94.9002 98.5736 86.1653 96.715 82.1836C87.4494 85.2051 74.8426 90.2217 68.3139 92.4881C67.2589 92.8544 66.5112 93.7926 66.384 94.9022C66.2987 95.6457 66.3308 96.5444 66.6598 97.507C67.0998 98.7941 67.8916 99.6722 68.5945 100.238C69.2986 100.804 70.2273 101.009 71.1049 100.793C86.4212 97.026 84.5587 98.8055 100.349 94.9002Z",
    fill: "#654D8F"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M100.349 94.8986C102.261 94.2092 102.794 90.8297 101.539 87.3502C100.285 83.8708 97.7176 81.6091 95.8057 82.2985C93.8937 82.988 93.3609 86.3675 94.6155 89.8469C95.8702 93.3264 98.4372 95.5881 100.349 94.8986Z",
    fill: "url(#paint9_linear_6783_40298)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M100.162 93.4025C101.488 92.9243 101.77 90.3356 100.791 87.6206C99.8115 84.9055 97.9427 83.0923 96.6164 83.5706C95.29 84.0488 95.0085 86.6375 95.9875 89.3525C96.9665 92.0675 98.8354 93.8808 100.162 93.4025Z",
    fill: "url(#paint10_linear_6783_40298)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9087 105.265C74.9087 105.265 73.0977 104.289 71.3486 103.422C69.5994 102.554 69.7738 100.941 68.3669 99.4343L66.96 97.9279C66.96 97.9279 68.6267 97.3394 69.5994 98.8377C70.5721 100.336 72.5026 100.453 72.5026 100.453L73.899 100.122L75.4745 103.624L74.9087 105.265Z",
    fill: "url(#paint11_linear_6783_40298)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9732 101.583C87.2885 100.884 97.6548 108.651 99.677 118.337C102.402 131.388 89.4341 145.323 75.9276 144.073C63.8407 142.954 51.8712 129.226 54.7669 114.616C56.8718 113.804 61.6911 113.557 65.4163 113.467C75.8333 113.215 82.9736 119.559 83.956 118.362C84.5297 117.663 82.7873 114.656 73.158 104.874C73.763 103.777 74.3682 102.68 74.9732 101.583Z",
    fill: "#8176AC"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6772 118.337C98.5538 112.956 94.8541 108.168 89.6765 105.094C92.2434 107.527 93.7272 109.541 94.4997 111.214C94.8637 112.002 95.2656 113.506 95.0542 115.287C94.5955 119.151 91.3603 120.03 88.34 124.62C85.2238 129.357 86.8511 131.183 84.5974 132.734C79.8895 135.972 71.9006 128.613 68.5977 131.295C67.2991 132.349 66.617 135.042 68.8492 141.979C71.0668 143.116 73.4582 143.844 75.9278 144.073C89.4343 145.323 102.402 131.388 99.6772 118.337Z",
    fill: "#654D8F"
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0253 166.956C31.7799 167.743 31.5345 168.53 31.289 169.317C29.5809 169.793 20.8135 172.047 12.4252 167.01C4.31727 162.141 0.918471 153.074 1.1304 145.825C1.62255 128.99 21.6374 120.162 23.8894 119.207C29.9349 116.644 35.9644 116.012 45.7194 114.989C53.0942 114.216 56.7815 113.83 59.083 114.733C70.3379 119.151 74.3663 139.643 73.7215 150.898C73.3429 157.507 71.2107 163.415 73.8329 171.023C74.2641 172.274 74.8104 173.532 74.2343 174.736C72.6474 178.051 65.0174 175.791 52.3602 176.04C39.6034 176.291 34.4056 178.842 32.2923 175.84C30.4626 173.24 33.2117 169.698 34.7004 163.598C36.0785 157.952 36.4963 149.625 31.891 138.212C30.9919 138.78 24.9687 142.727 23.9642 150.253C23.1046 156.693 26.259 163.218 32.0253 166.956Z",
    fill: "#8176AC"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7783 166.006C55.325 160.7 58.7132 155.515 54.6678 150.153C51.3899 145.808 47.9581 147.612 42.6271 142.928C35.602 136.756 36.8457 129.481 33.0948 128.981C29.0513 128.443 23.5657 136.359 22.6595 144.032C22.1886 148.018 23.0129 151.438 23.8907 153.816C23.7841 152.637 23.8049 151.444 23.964 150.253C24.9685 142.727 30.9916 138.78 31.8907 138.212C36.4961 149.625 36.0783 157.952 34.7002 163.598C33.2114 169.698 30.4623 173.24 32.2921 175.84C34.4054 178.842 39.6032 176.291 52.36 176.04C64.9591 175.792 72.5762 178.03 74.2109 174.78C63.6586 173.13 59.4187 169.555 57.7783 166.006L57.7783 166.006Z",
    fill: "#8176AC"
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7099 167.292C30.7099 167.292 35.455 164.65 37.0171 164.802C38.5792 164.954 40.1648 168.013 40.8443 168.615C41.5238 169.217 38.4305 169.788 37.0171 169.202C35.6038 168.615 32.757 170.931 31.1192 169.749C29.4814 168.567 30.7099 167.292 30.7099 167.292Z",
    fill: "url(#paint12_linear_6783_40298)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9448 105.78C44.9448 105.78 45.3852 115.54 36.7168 116.015C36.7168 116.015 47.0817 120.421 49.6207 121.089C52.1598 121.757 55.7404 114.427 55.7404 114.427L52.9834 113.726C51.765 113.416 50.8019 112.483 50.4585 111.273C50.1675 110.248 49.9396 109.025 50.1389 108.11C50.5543 106.204 44.9448 105.78 44.9448 105.78L44.9448 105.78Z",
    fill: "url(#paint13_linear_6783_40298)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2252 102.597C52.094 101.265 53.8328 98.5997 52.8855 97.0916C52.1767 95.9633 50.5136 96.3578 49.8272 94.9945C49.3101 93.968 50.0555 93.3514 49.6524 92.2858C49.0176 90.6078 46.1185 89.3578 44.3222 90.1886C42.4454 91.0567 43.1291 93.5688 40.9144 94.8198C39.3914 95.6801 38.4762 94.8266 37.3318 95.7811C35.9879 96.9019 35.8664 99.2334 36.3707 100.849C36.8416 102.358 37.8346 103.167 39.7545 104.686C42.2979 106.699 43.5696 107.706 45.2015 107.654C47.9844 107.564 49.8325 104.732 51.2252 102.597Z",
    fill: "url(#paint14_linear_6783_40298)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7212 104.69C42.7212 104.69 40.8239 103.009 39.5007 103.819C38.1775 104.629 41.7136 108.068 43.4998 107.614L42.7212 104.69Z",
    fill: "url(#paint15_linear_6783_40298)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0075 99.4298C50.9921 99.4142 51.409 101.611 51.409 101.611L52.0075 105.103C54.0322 103.7 53.0229 99.4454 52.0075 99.4298Z",
    fill: "url(#paint16_linear_6783_40298)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8763 99.6503C52.2832 101.745 52.1929 104.019 52.1127 104.748C51.9516 106.211 51.6753 108.721 49.8524 109.659C47.6841 110.775 44.8608 109.029 43.4994 107.615C41.7603 105.808 40.6566 102.737 41.7644 101.28C42.1712 100.745 42.5067 100.913 44.1101 100.21C47.0619 98.9147 47.6641 97.5802 48.9533 97.8487C49.7826 98.0215 50.2542 98.7239 50.8764 99.6503H50.8763Z",
    fill: "url(#paint17_linear_6783_40298)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6783_40298",
    x1: 50.1561,
    y1: 31.6812,
    x2: 11.1491,
    y2: 142.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    stopColor: "#E38DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6783_40298",
    x1: 80.9647,
    y1: 119.221,
    x2: -9.27003,
    y2: -36.8091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6783_40298",
    x1: 56.7088,
    y1: 31.8136,
    x2: 103.626,
    y2: 109.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    stopColor: "#E38DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6783_40298",
    x1: 170.561,
    y1: 103.924,
    x2: 120.918,
    y2: 103.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC120"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6783_40298",
    x1: 87.304,
    y1: 104.021,
    x2: 29.4056,
    y2: 104.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC120"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6783_40298",
    x1: 121.009,
    y1: 103.924,
    x2: 87.1494,
    y2: 103.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC120"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6783_40298",
    x1: 61.0703,
    y1: 106.958,
    x2: 60.1689,
    y2: 106.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A03976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6783_40298",
    x1: 144.211,
    y1: 104.037,
    x2: 143.31,
    y2: 104.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A03976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6783_40298",
    x1: 166.64,
    y1: 81.8786,
    x2: 34.0889,
    y2: 81.8786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A03976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6783_40298",
    x1: 87.8759,
    y1: 91.3515,
    x2: 113.6,
    y2: 84.4016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6783_40298",
    x1: 100.803,
    y1: 87.6159,
    x2: 95.9872,
    y2: 89.3521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC120"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6783_40298",
    x1: 71.0819,
    y1: 98.6852,
    x2: 72.4364,
    y2: 119.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.052,
    stopColor: "#FDB946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.142,
    stopColor: "#FEC144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#FDB946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#F99C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    stopColor: "#F8924F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8924F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_6783_40298",
    x1: 38.423,
    y1: 164.279,
    x2: 25.4792,
    y2: 183.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.052,
    stopColor: "#FDB946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.142,
    stopColor: "#FEC144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#FDB946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#F99C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    stopColor: "#F8924F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8924F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_6783_40298",
    x1: 45.8982,
    y1: 126.784,
    x2: 46.5003,
    y2: 105.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.052,
    stopColor: "#FDB946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.142,
    stopColor: "#FEC144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#FDB946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#F99C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    stopColor: "#F8924F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8924F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_6783_40298",
    x1: 44.6324,
    y1: 98.1831,
    x2: 44.8945,
    y2: 73.8039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40447E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#3C3B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_6783_40298",
    x1: 43.0471,
    y1: 110.93,
    x2: 37.2353,
    y2: 93.2522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.052,
    stopColor: "#FDB946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.142,
    stopColor: "#FEC144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#FDB946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#F99C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    stopColor: "#F8924F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8924F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_6783_40298",
    x1: 53.9376,
    y1: 107.349,
    x2: 48.1258,
    y2: 89.6717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.052,
    stopColor: "#FDB946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.142,
    stopColor: "#FEC144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#FDB946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#F99C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    stopColor: "#F8924F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8924F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_6783_40298",
    x1: 48.7198,
    y1: 109.159,
    x2: 43.443,
    y2: 93.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.052,
    stopColor: "#FDB946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.142,
    stopColor: "#FEC144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#FDB946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#F99C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    stopColor: "#F8924F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8924F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResults);
export default __webpack_public_path__ + "static/media/NoResults.8d8f8f9574364fa7d1604dda49036c49.svg";
export { ForwardRef as ReactComponent };